import { Typography, Box, Divider } from '@wishket/design-system';

import { Icon } from '@/shared/Components';
import { SubCountProps } from '@/shared/types';

export const SubCount = ({ changedCount }: SubCountProps) => {
  if (changedCount === null) {
    return (
      <Typography
        data-testid="subcount-new-count"
        variant="caption2"
        className="font-bold text-primary-500"
      >
        NEW
      </Typography>
    );
  }

  if (changedCount > 0) {
    return <UpCount changedCount={changedCount} />;
  }

  if (changedCount < 0) {
    return <DownCount changedCount={changedCount} />;
  }

  return (
    <Box data-testid="subcount-zero-count">
      <Divider className="w-2 bg-w-gray-400" />
    </Box>
  );
};

export interface CountProps {
  changedCount: number;
}

const UpCount = ({ changedCount }: CountProps) => {
  return (
    <Box className="flex items-center gap-1" data-testid="subcount-up-count">
      <Icon name="increase_triangle" />
      <Typography variant="caption2" className="font-bold text-w-red-500">
        {changedCount}
      </Typography>
    </Box>
  );
};

const DownCount = ({ changedCount }: CountProps) => {
  return (
    <Box className="flex items-center gap-1" data-testid="subcount-down-count">
      <Icon name="decrease_triangle" />
      <Typography variant="caption2" className="font-bold text-w-primary">
        {-changedCount}
      </Typography>
    </Box>
  );
};
